const mutations = {
  getHomepages: (state, homepage) => {
    state.homepage = homepage;
  },
  getHomepage: (state, homepage_id) => {
    state.homepage_id = homepage_id;
  },
  getArticle: (state, get_article) => {
    state.get_article = get_article;
  },
  postHomepage: (state, new_homepage) => {
    state.homepage.push(new_homepage);
  },
  putHomepage: (state, payload) => {
    state.homepage = state.homepage.map((homepage) => {
      if (homepage.homepage_id === payload.id) {
        return Object.assign({}, homepage, payload.formData);
      }
      return homepage;
    });
  },
  delHomepage(state, id) {
    const index = state.homepage.findIndex(homepage => homepage.homepage_id == id);
    state.homepage.splice(index, 1);
  },
};

export default mutations;
